import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, List, styled, Typography } from '@mui/material';

export const LeftArrowIconStyled = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'isOnlyForNavigation',
})(({ theme, isOnlyForNavigation }) => ({
  height: '24px',
  color: isOnlyForNavigation
    ? theme.palette.colors.onSecondaryAndDetailBackground
    : theme.palette.colors.onPrimaryBackground,
}));

export const ListMobileStyled = styled(List, {
  shouldForwardProp: (prop) => prop !== 'isOnlyForNavigation',
})(({ theme, isOnlyForNavigation }) => ({
  display: 'flex',
  justifyContent: !isOnlyForNavigation && 'space-between',
  gap: '16px',
  alignItems: 'center',
  width: isOnlyForNavigation && '328px',
  marginInline: isOnlyForNavigation && 'auto',

  [theme.breakpoints.up('sm')]: {
    width: isOnlyForNavigation && '468px',
  },
  [theme.breakpoints.up('md')]: {
    width: isOnlyForNavigation ? '436px' : '603px',
  },
}));

export const ListWrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isOnlyForNavigation' && prop !== 'isAtBottom',
})(({ theme, isOnlyForNavigation, isAtBottom }) => ({
  width: '100%',
  height: '56px',
  backgroundColor: isOnlyForNavigation
    ? theme.palette.colors.actionBar
    : theme.palette.colors.primaryBackground,
  borderTop: `1px solid ${theme.palette.colors.scrollOnPrimaryBackground}`,
  display: 'flex',
  justifyContent: !isOnlyForNavigation && 'center',
  position: 'fixed',
  bottom: isAtBottom ? 0 : '71px',
  zIndex: 1200,
}));

export const NavigationLabel = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textTransform: 'uppercase',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));
